import { menuStyles as m } from "./menu.styles.js";
import { FASTMenu as s, menuTemplate as i } from "@matrix42/fast-foundation";
const e = class e extends s {
};
e.definition = {
  name: "menu",
  template: () => i(),
  styles: () => m
};
let t = e;
export {
  t as Menu
};
